import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQS = [
  {
    q: "Is there really a free plan?",
    a: "Yes — start with 10 clients for free. Enough to test FitTrackCoach, organise your existing clients, and close your first paying ones. No credit card, no trial expiry, no gimmicks.",
  },
  {
    q: "Can my clients access their plans on mobile?",
    a: "100%. Your clients open their phone, see their workouts, diet, and progress instantly — no app install, no friction. You look like a premium coach; they stay engaged longer.",
  },
  {
    q: "Do you support Indian foods in the diet planner?",
    a: "Yes. Dal, roti, paneer, poha, idli — hundreds of Indian foods with accurate macros. Build a personalised diet in minutes instead of hours, and deliver results your clients can actually follow.",
  },
  {
    q: "Can I import my existing clients?",
    a: "Absolutely. Bulk-import via CSV (Pro) or migrate from Excel/Sheets — we'll help you do it in under an hour. Switch once, and your coaching business stays organised forever.",
  },
  {
    q: "What happens to my data if I cancel?",
    a: "You own everything. Export every client profile, workout, and diet plan anytime in CSV/PDF. No lock-in, no hostage policies — your business stays yours, always.",
  },
  {
    q: "Do you offer discounts for annual billing?",
    a: "Yes — pay annually and save 20% on Pro and Elite. Reinvest those savings into ads or equipment, not software fees.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="py-20 md:py-28" data-testid="faq-section">
      <div className="section-container">
        <div className="text-center max-w-2xl mx-auto mb-12 reveal">
          <div className="chip mb-4">Still thinking?</div>
          <h2 className="font-display text-4xl md:text-5xl leading-tight">
            Still thinking? <span className="gradient-text">Let's clear everything.</span>
          </h2>
          <p className="mt-4 text-white/60">
            Everything you need to decide in the next 2 minutes.
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className="card-surface rounded-xl overflow-hidden reveal"
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 p-5 text-left"
                  aria-expanded={isOpen}
                  data-testid={`faq-toggle-${i}`}
                >
                  <span className="text-sm md:text-base font-semibold text-white">{f.q}</span>
                  <span
                    className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-colors ${
                      isOpen ? "bg-cyan-500/20 text-cyan-300" : "bg-white/5 text-white/60"
                    }`}
                  >
                    {isOpen ? <Minus size={14} /> : <Plus size={14} />}
                  </span>
                </button>
                <div
                  className="grid transition-all duration-300 ease-out"
                  style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm text-white/70 leading-relaxed">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
